export default "__VITE_ASSET__D5X5N_fC__"